import { defineMessages } from 'react-intl'

export default defineMessages({
  confirmDelete: {
    id: 'containers.SupplierTaskPage.components.FileList.confirmDelete',
    defaultMessage: 'Are you sure you want to delete this file ({title})',
  },
  
})
